import { Workflow } from "@common/ADAPT.Common.Model/embed/workflow";
import { WorkflowIdentifier } from "@org-common/lib/workflow/workflow-identifier.enum";
import { onboardingWorkflow } from "./onboarding/onboarding-workflow";

type WorkflowDefinitions = {
    [K in keyof typeof WorkflowIdentifier]?: Workflow;
};

export const Workflows: WorkflowDefinitions = {
    [WorkflowIdentifier.WelcomeOnboarding]: onboardingWorkflow,
};
